import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();

    return (
        <div className="privacy-policy-page bg-white min-vh-100">
            {/* Simple Header with Back Button */}
            <div className="sticky-top bg-white border-bottom px-3 py-3 d-flex align-items-center">
                <Button
                    variant="link"
                    className="text-dark p-0 me-3"
                    onClick={() => navigate(-1)}
                >
                    <i className="bi bi-chevron-left fs-4"></i>
                </Button>
                <h5 className="mb-0 fw-bold">개인정보처리방침</h5>
            </div>

            <div className="container py-4" style={{ maxWidth: '800px' }}>
                <p className="text-muted small mb-4">본 개인정보처리방침은 주식회사 선흥컴퍼니(이하 '회사')가 제공하는 '바로보고(barobogo)' 서비스 및 앱(이하 '서비스')과 관련하여 회원의 개인정보를 어떻게 수집, 이용, 보호하는지 안내합니다.</p>

                <h6 className="fw-bold mb-3">1. 수집하는 개인정보 항목</h6>
                <p className="small mb-4">앱은 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</p>
                <ul className="small mb-4">
                    <li><strong>회원가입 및 관리:</strong> 성명, 이메일 주소, 비밀번호, 소속 회사 정보</li>
                    <li><strong>서비스 이용 과정:</strong> 사진(카메라 촬영 데이터), 위치 정보(점검 위치 기록용), 시설 및 구역 정보, 서비스 이용 기록</li>
                    <li><strong>모바일 서비스:</strong> 기기 식별자(Push 알림용 Device Token)</li>
                </ul>

                <h6 className="fw-bold mb-3">2. 개인정보의 수집 및 이용 목적</h6>
                <p className="small mb-4">수집된 정보는 다음의 목적을 위해서만 사용됩니다.</p>
                <ul className="small mb-4">
                    <li>사용자 식별 및 권한별 접근 제어(소유자, 관리자, 직원 등)</li>
                    <li>시설 점검 보고 및 이슈 등록 시 증빙용 사진 첨부 및 위치 기록</li>
                    <li>이슈 발생 및 처리 상태에 대한 실시간 알림 전송</li>
                    <li>보안 강화 및 무단 이용 방지</li>
                </ul>

                <h6 className="fw-bold mb-3">3. 개인정보의 보유 및 이용 기간</h6>
                <p className="small mb-4">앱은 원칙적으로 서비스 탈퇴 시까지 또는 이용 목적이 달성될 때까지 개인정보를 보유합니다. 단, 관계 법령에 의해 보존할 필요가 있는 경우 해당 기간 동안 보관합니다.</p>

                <h6 className="fw-bold mb-3">4. 개인정보의 제3자 제공</h6>
                <p className="small mb-4">앱은 사용자의 개인정보를 제3자에게 제공하거나 공유하지 않습니다.</p>

                <h6 className="fw-bold mb-3">5. 개인정보의 안전성 확보 조치</h6>
                <p className="small mb-4">앱은 사용자의 중요 정보를 보호하기 위해 다음과 같은 조치를 취하고 있습니다.</p>
                <ul className="small mb-4">
                    <li><strong>데이터 저장소:</strong> 모든 데이터는 Google Cloud Platform(GCP)의 서울 리전(asia-northeast3) 내 보안 서버에 저장됩니다.</li>
                    <li><strong>암호화:</strong> 비밀번호는 일방향 해시 함수를 통해 암호화하여 저장하며, 모든 데이터 통신은 HTTPS 보안 프로토콜을 사용합니다.</li>
                    <li><strong>보안 관리:</strong> API 키 및 민감한 설정값은 GCP Secret Manager를 통해 안전하게 관리됩니다.</li>
                </ul>

                <h6 className="fw-bold mb-3">6. 카메라 및 위치 정보 권한 안내</h6>
                <p className="small mb-4">본 앱은 시설의 상태를 보고하고 이슈를 등록하기 위해 기기의 카메라 기능과 위치 정보 접근 권한을 사용합니다. 수집된 정보는 사용자가 직접 보고서를 전송할 때만 서버로 업로드되며, 부정 점검 방지 및 시설 관리의 정확성을 위해서만 사용됩니다.</p>

                <h6 className="fw-bold mb-3">7. 개인정보 보호책임자 및 삭제 요청</h6>
                <p className="small mb-4">개인정보 처리와 관련한 문의나 계정 삭제 요청은 시스템 내 관리자에게 요청하거나 다음 연락처로 문의해 주시기 바랍니다.</p>
                <p className="small mb-5">이메일: cs@sunheung.com</p>

                <div className="pt-4 border-top text-muted extra-small">
                    <p className="mb-1">시행 일자: 2026년 1월 27일</p>
                    <p>© 2026 Sunheung Company, Inc. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
